'use client';

import Image from '@/components/image';
import Modal from '.';
const options = [
  {
    'title-ar': 'الشريعه السمحة:',
    'title-en': 'Add the item to your cart',

    'desc-ar': 'لا فوائد, ولا رسوم تأخير, ولا تكاليف مخفية',
    'desc-en': 'Add the item to your cart',
    img: 'shariah-compliant',
  },
  {
    'title-ar': 'معلومات البطاقة أمنة بنسبة 100%',
    'title-en': 'Fill in your details',

    'desc-ar': 'تنفيذ أمان قوي وحماية.',
    'desc-en': 'Add the item to your cart',
    img: 'cards-secure',
  },
  {
    'title-ar': 'استمتع الاّن, وادفع لاحقا:',
    'title-en': 'Select MADFU at checkout',

    'desc-ar': 'بدون فوائد, وبدون رسوم تأخير, وبدون تكاليف مخفية',
    'desc-en': 'Add the item to your cart',
    img: 'pay-later',
  },
];

const MadfuWidgetModal = ({ show, onHide, locale }) => {
  return (
    <Modal
      isOpen={show}
      title={locale === 'ar' ? 'تقسيط حتى 6 دفعات' : 'Split up to 6 Payments'}
      onClose={onHide}
      maxWidth='max-w-lg'
    >
      <div className='p-3'>
        <p className='border-border border-b py-2 text-center text-sm font-semibold max-sm:text-xs sm:py-3'>
          {locale === 'en'
            ? 'Monthly payments With no interest, no late fees & no hidden costs'
            : 'يوم الراتب ادفع الحد الأدنى من 20% الاّن, مع الباقي المدفوع لاحقا'}
        </p>
        <div className='my-4 flex flex-1 flex-col items-center justify-center max-sm:py-3'>
          <div className='grid grid-cols-1 gap-6 md:grid-cols-2'>
            {options?.map((opt, index) => (
              <div
                key={index}
                className='flex flex-col items-center gap-2 last:col-span-full'
              >
                <Image
                  loading='eager'
                  priority='high'
                  src={`/imgs/payments/${opt.img}.png`}
                  alt={opt['title-' + locale]}
                  className='h-8 object-contain lg:h-14'
                />
                <p className='text-xs font-bold sm:text-sm'>
                  {opt['title-' + locale]}
                </p>

                <p className='text-[10px] sm:text-xs'>
                  {opt['desc-' + locale]}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default MadfuWidgetModal;
